import { useState, useContext, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Flex, Space, Form, Input, DatePicker } from 'antd';
import TradeProcessService from '../../services/TradeProcessService';
import { TradesContext } from '../../contexts/tradeProcessContext';
import ConfirmModal from './ConfirmModal';

const { TextArea } = Input;

const MatchingForm = () => {
  const { showNotification } = useAuth();

  // consume context
  const { setMatchingData, currentStep, setCurrentStep, setOpenModal, registerForm, formValues } =
    useContext(TradesContext);

  // form controls
  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState('');

  const [confirmLoading, setConfirmLoading] = useState(false);

  // register form instance for external validation
  useEffect(() => {
    registerForm(form);
  }, [form, registerForm]);

  // call matching process api
  const handleOk = async () => {
    setConfirmLoading(true);

    const payload = {
      tradeWindow: formValues.tradeWindow.format('YYYYMMDD'),
      transferWindow: formValues.transferWindow.format('YYYYMMDD'),
      settlementWindow: formValues.settlementWindow.format('YYYYMMDD'),
      notes: formValues.notes.trim(),
    };

    const result = await TradeProcessService.performMatchingProcess(payload);

    if (result.success) {
      setMatchingData({
        success: result.data.success,
        records: result.data.matchingRecords,
      });

      setConfirmLoading(false);
      setOpenModal(false);
      setCurrentStep(currentStep + 1);
    } else {
      setConfirmLoading(false);
      setOpenModal(false);
      showNotification('error', result.message);
    }

    // to test without api
    // setMatchingData(
    //   { success: false, records: [] }
    // )
    // setConfirmLoading(false);
    // setOpenModal(false);
    // setCurrentStep(currentStep + 1);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  return (
    <Space
      direction="vertical"
      size={'large'}
      style={{
        width: '100%',
      }}
    >
      <Form
        layout="vertical"
        onFinish={handleOk}
        form={form}
        onValuesChange={onRequiredTypeChange}
        requiredMark={requiredMark}
      >
        <Flex wrap gap="middle">
          <Form.Item
            label={'Trade Window'}
            name={'tradeWindow'}
            rules={[
              {
                required: true,
                message: 'Please select the date',
              },
            ]}
            style={{
              flexGrow: 1,
            }}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            label={'Transfer Window (T+2)'}
            name={'transferWindow'}
            rules={[
              {
                required: true,
                message: 'Please select the date',
              },
            ]}
            style={{
              flexGrow: 1,
            }}
          >
            <DatePicker
              placeholder={'Trade Window + 2 Business Days'}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
          <Form.Item
            label={'Settlement Window (T+3)'}
            name={'settlementWindow'}
            rules={[
              {
                required: true,
                message: 'Please select the date',
              },
            ]}
            style={{
              flexGrow: 1,
            }}
          >
            <DatePicker
              placeholder={'Trade Window + 3 Business Days'}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
        </Flex>
        <Form.Item
          label={'Notes'}
          name={'notes'}
          rules={[
            {
              required: true,
              message: 'Please add notes',
            },
          ]}
        >
          <TextArea
            placeholder="Write additional information about current trade process"
            autoSize={{
              minRows: 3,
              maxRows: 6,
            }}
          />
        </Form.Item>
      </Form>

      <ConfirmModal
        title={'Please double check !'}
        description={'You have selected below dates to do matching process'}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
        okText="Confirm"
        cancelText="Cancel"
      />
    </Space>
  );
};

export default MatchingForm;
